import { initContract } from '@ts-rest/core';
import { z } from 'zod';
import { commonErrorResponses, emptyEnvelopeSchema, requiredPayloadEnvelope } from '../envelope.js';
import { realtimeNegotiateSchema } from '../common/schemas.js';
import { overlayKindSchema } from './kinds.js';
import { overlayRuntimeStatusReportSchema } from './overlay-runtime-status.schema.js';
import { overlayPlayAckSchema, overlayResolveSchema, overlayStateSchema } from './schemas.js';
const c = initContract();
const overlayTokenQuery = z.object({
    /** 능력 토큰(권장). OBS URL `?q=` 관례. */
    q: z.string().min(1).optional(),
    /** 레거시 별칭 — Guard가 `q` 다음으로 허용. */
    token: z.string().min(1).optional(),
});
/**
 * overlay-api 공개 계약(로그인 불필요).
 * 인증은 `OverlayTokenGuard` + 쿼리 `q`(능력 토큰)다 — AT/DPoP와 섞지 않는다.
 */
export const overlayApiContract = c.router({
    resolve: {
        method: 'GET',
        path: '/overlays/:kind/resolve',
        pathParams: z.object({ kind: overlayKindSchema }),
        query: overlayTokenQuery,
        responses: {
            200: requiredPayloadEnvelope(overlayResolveSchema),
            ...commonErrorResponses,
        },
    },
    /** Azure Web PubSub Client Access URL 발급 — 능력 토큰이 가리키는 유저·kind 그룹에만 join 가능한 토큰. */
    negotiate: {
        method: 'GET',
        path: '/overlays/:kind/negotiate',
        pathParams: z.object({ kind: overlayKindSchema }),
        query: overlayTokenQuery,
        responses: {
            200: requiredPayloadEnvelope(realtimeNegotiateSchema),
            ...commonErrorResponses,
        },
    },
    /** 재연결(셀프힐링) 시 초기 상태 + 이벤트 로그 조회 — `overlay-alert.md` 「재연결」. */
    state: {
        method: 'GET',
        path: '/overlays/:kind/state',
        pathParams: z.object({ kind: overlayKindSchema }),
        query: overlayTokenQuery,
        responses: {
            200: requiredPayloadEnvelope(overlayStateSchema),
            ...commonErrorResponses,
        },
    },
    /** 오버레이가 재생 진입을 확인 — stream-processor 내부 엔드포인트로 프록시. */
    playStarted: {
        method: 'POST',
        path: '/overlays/:kind/play-started',
        pathParams: z.object({ kind: overlayKindSchema }),
        query: overlayTokenQuery,
        body: overlayPlayAckSchema,
        responses: {
            200: emptyEnvelopeSchema,
            ...commonErrorResponses,
        },
    },
    /** 오버레이가 재생 완료를 보고 — stream-processor 내부 엔드포인트로 프록시. */
    playEnded: {
        method: 'POST',
        path: '/overlays/:kind/play-ended',
        pathParams: z.object({ kind: overlayKindSchema }),
        query: overlayTokenQuery,
        body: overlayPlayAckSchema,
        responses: {
            200: emptyEnvelopeSchema,
            ...commonErrorResponses,
        },
    },
    /**
     * overlay-web이 인스턴스 생존·언락 단계를 보고한다.
     * userId는 능력 토큰에서만 읽는다. 본문에 두지 않는다.
     */
    runtimeStatus: {
        method: 'POST',
        path: '/overlays/:kind/runtime-status',
        pathParams: z.object({ kind: overlayKindSchema }),
        query: overlayTokenQuery,
        body: overlayRuntimeStatusReportSchema,
        responses: {
            200: emptyEnvelopeSchema,
            ...commonErrorResponses,
        },
    },
});
//# sourceMappingURL=overlay-api.contract.js.map